export const mvpCleanupEn = {
  collectStop: 'Collect',
  stopCollected: 'Stop collected',
  optimizeComingSoon: 'Optimize coming soon',
  optimizeComingSoonHint: 'Route reordering will be available in a later update.',
  optimizeRoute: 'Optimize route',
  optimizeRouteDone: 'Route order updated',
  optimizeRouteFailed: 'Could not optimize route',
  optimizeRouteHint: 'Reorders pickups for a shorter path (high priority first). Does not send the route to the runner — only Authorize departure does.',
  routeDepartReleaseHint: 'Authorize departure to release this route to the runner for immediate collection.',
  stopPriority: 'Priority',
  stopPriorityHigh: 'High',
  stopPriorityNormal: 'Normal',
  routeIdleAlertMin: 'Idle alert (minutes)',
  routeIdleAlertHint: 'Notify banker and god if the runner does not advance along the route for this many minutes (default 10).',
  runnerMaxLoadAmount: 'Runner max load',
  runnerMaxLoadHint: 'Maximum cash a runner may carry when combining several house routes in one run (default 1,000,000).',
  routeDepartBlockedInProgress: 'Previous departure is still in progress. Finish collecting before authorizing again.',
  routeCollectionCompleted: 'Collection completed',
  routeCompleteManual: 'Mark completed (exceptional)',
  routeCompleteManualBody: 'Route marked completed manually. You can authorize a new departure when ready.',
  routeCompleteFailed: 'Could not mark the route as completed.',
  routeCompleteNeedsConfirm: 'Confirm before marking the route completed.',
  routeCompleteConfirmTitle: 'Force-complete route?',
  routeCompleteConfirmBody: 'Exceptional action. Use only if the collection cannot finish normally. Pending stops stay as-is; this unlocks a new authorization and is fully audited.',
  routeCompleteConfirmHint: 'A clear reason is required (min. 3 characters). The event is written to the audit log.',
  routeCompleteReasonLabel: 'Reason (required)',
  routeCompleteReasonPlaceholder: 'Why force-complete this collection?',
  routeCompleteReasonRequired: 'Enter a reason before confirming.',
  routeCompleteConfirmAction: 'Confirm force-complete',
  houseAddressPlaceholder: 'Address (street, city)',
  houseAddressGeocodeHint: 'Physical address is located automatically (lat/lng) when geocoding is configured.',
  draftRoute: 'Draft route',
  confirmRoute: 'Confirm & assign',
  assignRoute: 'Assign',
  routeAssigned: 'Route configured',
  routeAssignedBody: 'Route is locked until you change the runner or stops. Authorize departure to release it to the runner.',
  routeStatusDraft: 'Configuring today’s route…',
  routeStatusConfirmed: 'Configured — waiting for departure',
  routeStatusNone: 'Preparing today’s route…',
  routeStatusPreparing: 'Preparing today’s route…',
  routeStatusConfigured: 'Configured — waiting for departure',
  routeStatusLive: 'Released to runner',
  selectHouseFirst: 'Select a house before drafting a route.',
  assignRunner: 'Runner',
  selectRunner: 'Select runner…',
  routeDraftCreated: 'Route draft created',
  routeDraftHint: 'Route stays as configured until you change the runner or stops.',
  routeDraftFailed: 'Could not draft route',
  routeConfirmed: 'Route configured',
  routeConfirmedBody: 'Authorize departure when you want the runner to start.',
  routeConfirmFailed: 'Could not configure route',
  adhocStopName: 'Ad-hoc stop name',
  adhocStopAddr: 'Address (geocoded)',
  adhocStopLabel: 'Ad-hoc',
  addAdhocStop: 'Add stop',
  adhocStopAdded: 'Stop added',
  adhocStopFailed: 'Could not add stop',
  deleteAdhocStop: 'Remove stop',
  deleteAdhocStopFailed: 'Could not remove stop',
  routeDestination: 'HQ destination',
  routeDepartAutoSkipHint: 'On authorize, official stops with nothing to collect are skipped automatically.',
  routeCompositionStatus: 'Route',
  sessionIdleWarnTitle: 'Session about to expire',
  sessionIdleWarnBody: 'You’ve been inactive. Stay signed in or you’ll be signed out soon.',
  sessionIdleExtend: 'Stay signed in',
  sessionIdleSignOut: 'Sign out now',
  compensationType: 'Compensation',
  compensationPercent: '% of collections',
  compensationFixed: 'Fixed fee',
  fixedFeeLabel: 'Fixed fee amount',
  agreementEnableAssignments: 'Enable service agreement (can receive route assignments)',
  routeAssignmentBlocked: 'This runner cannot receive route assignments yet.',
  dismiss: 'Dismiss',
  scheduleUpdated: 'Schedule updated',
  coinsIn: 'Coins in',
  coinsOut: 'Coins out',
  flagDevPanel: 'Dev panel',
  flagDevPanelDesc: 'Shows the god Dev panel menu when enabled. Default off in production builds.',
  exchangeRatesRefresh: 'Refresh rates',
  exchangeRatesRefreshPending: 'Refreshing…',
  exchangeRatesRefreshConfirm:
    'This will fetch and publish the latest rate. If it fails, the previous published rate stays in place. Continue?',
  exchangeRatesRefreshSuccess: 'Rates updated.',
  exchangeRatesRefreshFailed: 'Could not refresh rates.',
  exchangeRatesRefreshFailedHint: 'The previous published rate was kept.',
  lotteryForceSyncTitle: 'Force lottery sync',
  lotteryForceSyncHint: 'Manual fetch + publish when auto-sync missed or returned incomplete picks. God and support only.',
  lotteryRecoverTitle: 'Refresh lottery results',
  lotteryRecoverHint: 'Only for Día/Noche turns past their sync window that still have no results.',
  resultsTurnUpcomingBadge: 'Pending',
  resultsTurnUpcomingHint: 'This turn has not started yet. It activates when its window opens.',
  lotteryForceSyncConfirm: 'Fetch and publish {source} {session} results now?',
  lotteryForceSyncBusy: 'Syncing…',
  lotteryForceSyncOk: 'Results sync completed',
  lotteryForceSyncOkBody: '{source} {session} published (or already settled).',
  lotteryForceSyncFailed: 'Results sync did not publish',
  lotteryForceSyncFailedHint: 'Sources may still be incomplete. Try again in a few minutes.',
  lotteryForceFlMidday: 'Florida midday',
  lotteryForceFlEvening: 'Florida evening',
  lotteryForceNyMidday: 'New York midday',
  lotteryForceNyEvening: 'New York evening',
  godResultsKicker: 'Platform draw results',
  godResultsHint: 'One shared feed for every house. Official Día/Noche numbers by lottery — recover feeds or publish a turn once; all houses on that lottery read the same data.',
  godResultsDate: 'Date',
  godResultsWindow: 'Turn',
  godResultsWindowAll: 'Day + Night',
  godResultsSource: 'Lottery',
  godResultsSourceAll: 'Florida + New York',
  godResultsMissing: 'Missing',
  godResultsMissingHint: 'No system draw for this turn. Use force sync or publish the draw.',
  godResultsPublishGlobal: 'Publish draw',
  godResultsPublishHint: 'Writes the official result to the platform store. Every house on that lottery reads it — no per-house copies for display.',
  godResultsPublishLocked: 'Available while the active turn window is open (manual), or after auto-publish ends with no numbers yet.',
  godResultsPick3: 'Pick 3',
  godResultsPick4: 'Pick 4',
  godResultsNumbers: 'Numbers',
  godResultsWin4: 'Win 4',
  godResultsCash3: 'Cash 3',
  godResultsCash4: 'Cash 4',
  godResultsPublishedBody: '{source} {window} published to platform ({count} houses settled on that lottery).',
  godYoutubeUrlLabel: 'YouTube draw',
  godYoutubeUrlHint: 'Paste the official watch URL for this turn (overrides auto).',
  publishResultsOverrideHint: 'Publish for the selected date and turn (exceptional backfill).',
  godHousesHint: 'Create houses and focus one to inspect its books.',
  godHousesEmpty: 'No houses yet. Create the first one below.',
  godHousesFocus: 'Focus',
  godHousesFocused: 'In focus',
  godHousesClearFocus: 'Clear focus',
  godHouseCreated: 'House created',
  godHousesCreateHint: 'Name the house. Staff and config can follow after.',
  godHousesNet: 'Net',
} as const;

export const mvpCleanupEs = {
  collectStop: 'Cobrar',
  stopCollected: 'Parada cobrada',
  optimizeComingSoon: 'Optimizar pronto',
  optimizeComingSoonHint: 'El reordenamiento de ruta estará disponible en una actualización posterior.',
  optimizeRoute: 'Optimizar ruta',
  optimizeRouteDone: 'Orden de ruta actualizado',
  optimizeRouteFailed: 'No se pudo optimizar la ruta',
  optimizeRouteHint: 'Reordena las paradas para un recorrido más corto (prioridad alta primero). No envía la ruta al runner: eso solo lo hace Autorizar salida.',
  routeDepartReleaseHint: 'Autoriza la salida para liberar esta ruta al runner y que cobre cuanto antes.',
  stopPriority: 'Prioridad',
  stopPriorityHigh: 'Alta',
  stopPriorityNormal: 'Normal',
  routeIdleAlertMin: 'Alerta de inactividad (minutos)',
  routeIdleAlertHint: 'Avisa al banker y al god si el runner no avanza en la ruta durante estos minutos (por defecto 10).',
  runnerMaxLoadAmount: 'Tope de carga del runner',
  runnerMaxLoadHint: 'Monto máximo que un runner puede cargar al unir varias rutas de casas en una sola corrida (por defecto 1.000.000).',
  routeDepartBlockedInProgress: 'La salida anterior sigue en curso. Termina el cobro antes de autorizar otra.',
  routeCollectionCompleted: 'Cobro completado',
  routeCompleteManual: 'Marcar completada (excepcional)',
  routeCompleteManualBody: 'Ruta marcada como completada manualmente. Puedes autorizar una nueva salida cuando quieras.',
  routeCompleteFailed: 'No se pudo marcar la ruta como completada.',
  routeCompleteNeedsConfirm: 'Confirma antes de marcar la ruta como completada.',
  routeCompleteConfirmTitle: '¿Forzar cobro completado?',
  routeCompleteConfirmBody: 'Acción excepcional. Úsala solo si el cobro no puede cerrarse con normalidad. Las paradas pendientes quedan como están; se desbloquea una nueva autorización y queda auditado.',
  routeCompleteConfirmHint: 'El motivo es obligatorio (mín. 3 caracteres). El evento se escribe en el log de auditoría.',
  routeCompleteReasonLabel: 'Motivo (obligatorio)',
  routeCompleteReasonPlaceholder: '¿Por qué fuerzas el cierre de este cobro?',
  routeCompleteReasonRequired: 'Escribe un motivo antes de confirmar.',
  routeCompleteConfirmAction: 'Confirmar cierre forzado',
  houseAddressPlaceholder: 'Dirección (calle, ciudad)',
  houseAddressGeocodeHint: 'La dirección física se ubica automáticamente (lat/lng) si el geocoding está configurado.',
  draftRoute: 'Borrador de ruta',
  confirmRoute: 'Confirmar y asignar',
  assignRoute: 'Asignar',
  routeAssigned: 'Ruta configurada',
  routeAssignedBody: 'La ruta queda fija hasta que cambies el runner o las paradas. Autoriza la salida para liberarla al runner.',
  routeStatusDraft: 'Configurando la ruta de hoy…',
  routeStatusConfirmed: 'Configurada — pendiente de salida',
  routeStatusNone: 'Preparando la ruta de hoy…',
  routeStatusPreparing: 'Preparando la ruta de hoy…',
  routeStatusConfigured: 'Configurada — pendiente de salida',
  routeStatusLive: 'Liberada al runner',
  selectHouseFirst: 'Selecciona una casa antes de crear el borrador.',
  assignRunner: 'Runner',
  selectRunner: 'Elegir runner…',
  routeDraftCreated: 'Borrador de ruta creado',
  routeDraftHint: 'La ruta se mantiene hasta que cambies el runner o las paradas.',
  routeDraftFailed: 'No se pudo crear el borrador',
  routeConfirmed: 'Ruta configurada',
  routeConfirmedBody: 'Autoriza la salida cuando quieras que el runner empiece.',
  routeConfirmFailed: 'No se pudo configurar la ruta',
  adhocStopName: 'Nombre de parada ad hoc',
  adhocStopAddr: 'Dirección (geocodificada)',
  adhocStopLabel: 'Ad hoc',
  addAdhocStop: 'Añadir parada',
  adhocStopAdded: 'Parada añadida',
  adhocStopFailed: 'No se pudo añadir la parada',
  deleteAdhocStop: 'Quitar parada',
  deleteAdhocStopFailed: 'No se pudo quitar la parada',
  routeDestination: 'Destino HQ',
  routeDepartAutoSkipHint: 'Al autorizar, las paradas oficiales sin monto por recoger se saltan solas.',
  routeCompositionStatus: 'Ruta',
  sessionIdleWarnTitle: 'La sesión está por cerrarse',
  sessionIdleWarnBody: 'Llevas tiempo inactivo. Quédate conectado o se cerrará la sesión pronto.',
  sessionIdleExtend: 'Seguir conectado',
  sessionIdleSignOut: 'Cerrar sesión ahora',
  compensationType: 'Compensación',
  compensationPercent: '% sobre colectas',
  compensationFixed: 'Tarifa fija',
  fixedFeeLabel: 'Monto de tarifa fija',
  agreementEnableAssignments: 'Habilitar acuerdo de servicio (puede recibir asignaciones)',
  routeAssignmentBlocked: 'Este runner aún no puede recibir asignaciones de ruta.',
  dismiss: 'Descartar',
  scheduleUpdated: 'Horarios actualizados',
  coinsIn: 'Entrada',
  coinsOut: 'Salida',
  flagDevPanel: 'Panel de desarrollo',
  flagDevPanelDesc: 'Muestra el menú Dev del god cuando está activado. Por defecto apagado en builds de producción.',
  exchangeRatesRefresh: 'Refrescar tasas',
  exchangeRatesRefreshPending: 'Actualizando…',
  exchangeRatesRefreshConfirm:
    'Esto intentará buscar y publicar la tasa más reciente. Si falla, se mantiene la tasa previa. ¿Continuar?',
  exchangeRatesRefreshSuccess: 'Tasas actualizadas.',
  exchangeRatesRefreshFailed: 'No se pudo actualizar la tasa.',
  exchangeRatesRefreshFailedHint: 'Se mantuvo la tasa previa publicada.',
  lotteryForceSyncTitle: 'Forzar sync de lotería',
  lotteryForceSyncHint: 'Fetch + publicación manual cuando el auto-sync falló o trajo picks incompletos. Solo god y soporte.',
  lotteryRecoverTitle: 'Actualizar resultados',
  lotteryRecoverHint: 'Solo para turnos Día/Noche fuera de horario que aún no tienen resultados.',
  resultsTurnUpcomingBadge: 'Pendiente',
  resultsTurnUpcomingHint: 'Este turno aún no llega. Se activa cuando abra su ventana.',
  lotteryForceSyncConfirm: '¿Buscar y publicar ahora resultados {source} {session}?',
  lotteryForceSyncBusy: 'Sincronizando…',
  lotteryForceSyncOk: 'Sync de resultados listo',
  lotteryForceSyncOkBody: '{source} {session} publicado (o ya asentado).',
  lotteryForceSyncFailed: 'El sync no publicó',
  lotteryForceSyncFailedHint: 'Las fuentes pueden seguir incompletas. Reintenta en unos minutos.',
  lotteryForceFlMidday: 'Florida mediodía',
  lotteryForceFlEvening: 'Florida noche',
  lotteryForceNyMidday: 'Nueva York mediodía',
  lotteryForceNyEvening: 'Nueva York noche',
  godResultsKicker: 'Resultados de plataforma',
  godResultsHint: 'Un solo feed compartido para todas las casas. Números oficiales de Día/Noche por lotería — recupera feeds o publica un turno una vez; todas las bancas de esa lotería leen lo mismo.',
  godResultsDate: 'Fecha',
  godResultsWindow: 'Turno',
  godResultsWindowAll: 'Día + Noche',
  godResultsSource: 'Lotería',
  godResultsSourceAll: 'Florida + Nueva York',
  godResultsMissing: 'Falta',
  godResultsMissingHint: 'No hay sorteo de sistema para este turno. Usa force sync o publica el sorteo.',
  godResultsPublishGlobal: 'Publicar sorteo',
  godResultsPublishHint: 'Escribe el resultado oficial en el store de plataforma. Todas las bancas de esa lotería lo leen — sin copias por casa para la vista.',
  godResultsPublishLocked: 'Disponible con la ventana del turno activo abierta (manual), o cuando ya pasó el auto-publish y aún no hay números.',
  godResultsPick3: 'Pick 3',
  godResultsPick4: 'Pick 4',
  godResultsNumbers: 'Numbers',
  godResultsWin4: 'Win 4',
  godResultsCash3: 'Cash 3',
  godResultsCash4: 'Cash 4',
  godResultsPublishedBody: '{source} {window} publicado en plataforma ({count} bancas liquidadas con esa lotería).',
  godYoutubeUrlLabel: 'Sorteo en YouTube',
  godYoutubeUrlHint: 'Pega la URL oficial del video de este turno (sustituye el auto).',
  publishResultsOverrideHint: 'Publica para la fecha y turno seleccionados (backfill excepcional).',
  godHousesHint: 'Crea bancas y enfoca una para inspeccionar sus libros.',
  godHousesEmpty: 'Aún no hay bancas. Crea la primera abajo.',
  godHousesFocus: 'Enfocar',
  godHousesFocused: 'En foco',
  godHousesClearFocus: 'Quitar foco',
  godHouseCreated: 'Banca creada',
  godHousesCreateHint: 'Nombra la banca. El personal y la config vienen después.',
  godHousesNet: 'Neto',
} as const;
